<template>
  <router-view></router-view>
  <!-- <EleIndex /> -->
</template>
<script lang="ts" setup>
import { onMounted } from "vue";
// import EleIndex from "@/components/EleIndex.vue";
declare global {
  interface Window {
    US?: any;
  }
}
const electronWindow = window.US;
onMounted(() => {
  try {
    electronWindow.command((_: any, data: string) => {
      const socketData = decodeURI(data);
      try {
        const parsedData = JSON.parse(socketData);
        if (parsedData.actionType) {
          if (parsedData.actionType === "closeComputer") {
            try {
              if (electronWindow) {
                electronWindow.wakeupLocalApp("closeComputer");
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      } catch (error) {
        console.error("反序列化失败:", error);
      }
    });
  } catch (error) {
    console.log(error);
  }
});
</script>
<style>
#app {
  /* width: 100%;
  height: 100%; */
  margin: 0;
  padding: 0;
  height: 100vh;
  background-color: transparent;
}
</style>
